(function () {
  var root = document.querySelector('[data-decision-page]');
  if (!root) return;

  function emit(name, params) {
    var payload = Object.assign({}, params || {}, {
      send_to: 'G-QDH0E1G2RS',
      transport_type: 'beacon'
    });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['event', name, payload]);
  }

  emit('decision_page_view', {
    decision_page: root.dataset.decisionPage || ''
  });

  root.addEventListener('click', function (event) {
    var link = event.target.closest('[data-decision-product]');
    if (!link) return;
    emit('decision_product_click', {
      decision_page: root.dataset.decisionPage || '',
      product_handle: link.dataset.decisionProduct || ''
    });
  });
})();
